import * as React from "react";
import { Button } from "scuid-x";
import { GenErrorPage } from "./GenErrorPage";
import "./GenErrorPageWithButton.css";

export interface GenErrorPageProps {
  title: string;
  description: React.ReactChild;
  buttonTitle: string;
  onButtonPress: () => void;
  child?: React.ReactChild;
}

export const GenErrorPageWithButton: React.SFC<GenErrorPageProps> = (props) => {

  return (
    <GenErrorPage title={props.title} description={props.description}>
        <Button className={"GenErrorPageWithButton-button"} onClick={props.onButtonPress}>{props.buttonTitle}</Button>
        {props.child}
    </GenErrorPage>
  );
};



// WEBPACK FOOTER //
// ./src/components/GenErrorPageWithButton.tsx